import { Element, Type } from '../../../types/Survey/Element'
import {
  Core,
  SliderGroup,
  Slider,
  Selection,
  DynamicText,
  Element as AnswerElement,
  Type as AnswerType,
  DynamicTextAnswer,
  OrganizationUnitCooperationSelection,
  SliderDropdown,
  SliderDropdownGroup,
  BooleanSelection,
  NumberInput,
  DynamicNumberDescriptionAmountInput,
  DynamicNumberDescriptionAmountInputAnswer,
  AmountToggleInput,
  OrganizationUnitNumberInput,
  DynamicOptionsWithNumberAndSelectionOption,
  DynamicOptionsWithNumberAndSelection,
} from '../../../types/Survey/Answer/Element'
import { getUUID } from '../../../utility'

const transform = (e: Element): AnswerElement | false => {
  const core = {
    uuid: e.uuid,
    type: e.type,
  }
  if (e.type === Type.SLIDER_GROUP) {
    const element: SliderGroup = {
      ...(core as Core<AnswerType.SLIDER_GROUP>),
      sliders: e.sliders.map((s) => transform(s)).filter((e) => !!e) as Slider[],
    }
    return element
  } else if (e.type === Type.SLIDER) {
    const element: Slider = {
      ...(core as Core<AnswerType.SLIDER>),
      value: 0,
    }
    return element
  } else if (e.type === Type.SELECTION) {
    const element: Selection = {
      ...(core as Core<AnswerType.SELECTION>),
      selectedOptions: [],
    }
    return element
  } else if (e.type === Type.DYNAMIC_TEXT) {
    const element: DynamicText = {
      ...(core as Core<AnswerType.DYNAMIC_TEXT>),
      textAnswers: [getDynamicTextAnswer()],
    }
    return element
  } else if (e.type === Type.ORGANIZATION_UNIT_COOPERATION_SELECTION) {
    const element: OrganizationUnitCooperationSelection = {
      ...(core as Core<AnswerType.ORGANIZATION_UNIT_COOPERATION_SELECTION>),
      organizationUnitPrioSelectionList: [],
    }
    return element
  } else if (e.type === Type.SLIDER_DROPDOWN) {
    const element: SliderDropdown = {
      ...(core as Core<AnswerType.SLIDER_DROPDOWN>),
      value: 0,
      optionUUID: null,
    }
    return element
  } else if (e.type === Type.SLIDER_DROPDOWN_GROUP) {
    const element: SliderDropdownGroup = {
      ...(core as Core<AnswerType.SLIDER_DROPDOWN_GROUP>),
      sliderDropdowns: e.sliderDropdowns.map((s) => transform(s)).filter((e) => !!e) as SliderDropdown[],
    }
    return element
  } else if (e.type === Type.BOOLEAN_SELECTION) {
    const element: BooleanSelection = {
      ...(core as Core<AnswerType.BOOLEAN_SELECTION>),
      selectionValue: null,
    }
    return element
  } else if (e.type === Type.NUMBER_INPUT) {
    const element: NumberInput = {
      ...(core as Core<AnswerType.NUMBER_INPUT>),
      number: 0,
    }
    return element
  } else if (e.type === Type.DYNAMIC_NUMBER_DESCRIPTION_AMOUNT_INPUT) {
    const element: DynamicNumberDescriptionAmountInput = {
      ...(core as Core<AnswerType.DYNAMIC_NUMBER_DESCRIPTION_AMOUNT_INPUT>),
      numberAnswers: [getDynamicNumberDescriptionAmountAnswer()],
    }
    return element
  } else if (e.type === Type.AMOUNT_TOGGLE_INPUT) {
    const element: AmountToggleInput = {
      ...(core as Core<AnswerType.AMOUNT_TOGGLE_INPUT>),
      isEnabled: false,
      amount: 0,
    }
    return element
  } else if (e.type === Type.ORGANIZATION_UNIT_NUMBER_INPUT) {
    const element: OrganizationUnitNumberInput = {
      ...(core as Core<AnswerType.ORGANIZATION_UNIT_NUMBER_INPUT>),
      organizationUnitNumberInputList: [],
    }
    return element
  } else if (e.type === Type.DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION_OPTION) {
    const element: DynamicOptionsWithNumberAndSelectionOption = {
      ...(core as Core<AnswerType.DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION_OPTION>),
      name: e.name,
      isActive: false,
      number: 0,
      isNormSelected: false,
    }
    return element
  } else if (e.type === Type.DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION) {
    const element: DynamicOptionsWithNumberAndSelection = {
      ...(core as Core<AnswerType.DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION>),
      dynamicOptionsWithNumberAndSelection: e.dynamicOptionsWithNumberAndSelection
        .map((o) => transform(o))
        .filter((o) => !!o) as DynamicOptionsWithNumberAndSelectionOption[],
    }
    return element
  }
  return false
}

export const getDynamicTextAnswer = (): DynamicTextAnswer => {
  return {
    uuid: getUUID(),
    value: '',
  }
}

export const getDynamicNumberDescriptionAmountAnswer = (): DynamicNumberDescriptionAmountInputAnswer => {
  return {
    uuid: getUUID(),
    description: '',
    amount: 0,
    number: 0,
  }
}

export const getDynamicOptionsWithNumberAndSelectionOption = (): DynamicOptionsWithNumberAndSelectionOption => {
  return {
    uuid: getUUID(),
    name: '',
    type: AnswerType.DYNAMIC_OPTIONS_WITH_NUMBER_AND_SELECTION_OPTION,
    isActive: true,
    number: 0,
    isNormSelected: false,
  }
}

const transformElementsToAnswers = (elements: Element[]): AnswerElement[] => {
  const answerElements = elements.map((element) => transform(element)).filter((e) => !!e) as AnswerElement[]
  return answerElements
}

export default transformElementsToAnswers
